import React from 'react';
import PropTypes from 'prop-types';
import ShowGoogleMap from './components/GoogleMap/GoogleMap';

const MapWrapper = ({
  isPhysicalStore, latitude, longitude, googleMapApiKey,
}) => {
  if (isPhysicalStore) {
    return (
    // Important! Always set the container height explicitly
      <div
        id="single-store-page__map-canvas"
        className="map-with-panel__canvas"
        data-testid="single-store-page__map-canvas"
      >
        <ShowGoogleMap
          latitude={latitude}
          longitude={longitude}
          googleMapApiKey={googleMapApiKey}
        />
      </div>
    );
  }
  return null;
};

MapWrapper.propTypes = {
  isPhysicalStore: PropTypes.bool.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
};

export default MapWrapper;
